import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ContentViewComponent from '../../../../Component/ContentViewComponent/ContentViewComponent';
import { getRoutePathname } from '../../../../Handler/RouteHandler';
import { initFormHandler } from '../../../../Handler/FormHandler';
import { Grid2 as Grid } from '@mui/material';
import TextFieldComponent from '../../../../Component/TextFieldComponent/TextFieldComponent';
import ButtonComponent from '../../../../Component/ButtonComponent/ButtonComponent';
import MultipleSelectComponent from '../../../../Component/MultipleSelectComponent/MultipleSelectComponent';
import ApiHandler from '../../../../Handler/ApiHandler';
import { dispatch } from '../../../../App';
import { SnackbarOpen } from '../../../../Reducer/SnackBarReducer/SnackBarSlice';

function AdministratorUser(props) {
    const [loading, setLoading] = React.useState(true);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [isEdit, setIsEdit] = React.useState(true);
    const [info, setInfo] = React.useState();
    const [optionsRole, setOptionsRole] = React.useState([]);

    const params = useParams();
    const navigate = useNavigate();

    const [form, setForm] = React.useState({
        firstname: {
            name: "firstname",
            label: "Prénom",
            textHelper: "Saisissez le prenom.",
            type: "text",
            defaultValue: "",
            options: { validation: ["required"] },
        },
        lastname: {
            name: "lastname",
            label: "Nom",
            textHelper: "Saisissez le nom.",
            type: "text",
            defaultValue: "",
            options: { validation: ["required"] },
        },
        email: {
            name: "email",
            label: "Email",
            textHelper: "Saisissez l'email.",
            type: "text",
            defaultValue: "",
            options: { validation: ["required", "email"] },
        },
        password: {
            name: "password",
            label: "Mot de passe",
            textHelper: "Saisissez le mot de passe.",
            type: "password",
            defaultValue: "",
            options: { validation: ["required"] },
        },
        role: {
            name: "role",
            label: "Rôle",
            textHelper: "Selectionnez les rôles.",
            type: "array",
            defaultValue: "",
            options: { validation: ["required"] },
        },
    });
    const handlerForm = initFormHandler(form, setForm);
    React.useEffect(() => {
        handlerForm.start();
    }, [handlerForm]);

    React.useEffect(() => {
        setBreadcrumbs({
            title: 'Administrateur',
            context: isEdit ? 'Éditer un utilisateur' : 'Ajouter un utilisateur',
            description: '',
            links: [
                { label: "Liste des utilisateurs", path: getRoutePathname("administrator_user_list") }
            ]
        });

        ApiHandler.get({ route: 'select_role' }, (response) => { setOptionsRole(response.data) });

        setTimeout(() => {
            setLoading(false);
        }, 1500);
    }, [isEdit]);

    React.useEffect(() => {
        if (params.id === 'add') {
            setIsEdit(false);
        }
        else {
            ApiHandler.get({
                route: 'administrator_user_get',
                params: { id: params.id },
            },
                (response) => {
                    if (response.status === 200) {
                        handlerForm.setDataApi(response.data);
                        handlerForm.setValue('password', '123456');
                        setInfo(response.data);
                    }
                    else {
                        dispatch(
                            SnackbarOpen({
                                text:
                                    response.error && response.error.message
                                        ? response.error.message
                                        : "Une erreur inattendu s'est produite.",
                                variant: "error",
                            }),
                        );
                        navigate(getRoutePathname('administrator_user_list'));
                    }
                });
        }
    }, [handlerForm, navigate, params]);

    const save = () => {
        if (handlerForm.checkError() < 1) {
            handlerForm.setFormLoading(true);
            ApiHandler.post(
                {
                    route: isEdit ? "administrator_user_edit" : "administrator_user_add",
                    params: isEdit ? { id: info.id } : "",
                    data: handlerForm.getData(),
                },
                (response) => {
                    if (response.status === 200 || response.status === 201) {
                        dispatch(
                            SnackbarOpen({
                                text: isEdit ? "Utilisateur modifié avec succès" : "Utilisateur crée avec succès",
                                variant: "success",
                            }),
                        );
                    } else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    } else {
                        dispatch(
                            SnackbarOpen({
                                text:
                                    response.error && response.error.message
                                        ? response.error.message
                                        : "Une erreur inattendu s'est produite.",
                                variant: "error",
                            }),
                        );
                    }
                    handlerForm.setFormLoading(false);
                },
            );
        }
    };

    return (
        <ContentViewComponent loading={loading} breadcrumbs={breadcrumbs}>
            <Grid container spacing={1}>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <TextFieldComponent id={"lastname"} handler={handlerForm} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <TextFieldComponent id={"firstname"} handler={handlerForm} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <TextFieldComponent id={"email"} handler={handlerForm} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <TextFieldComponent id={"password"} handler={handlerForm} disabled={isEdit} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <MultipleSelectComponent id={'role'} options={optionsRole} handler={handlerForm} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <ButtonComponent style={{ width: '100%', marginTop: '20px' }} label={"Enregistrer"} onClick={save} />
                </Grid>
            </Grid>
        </ContentViewComponent>
    );
}

export default AdministratorUser;
